import { render } from "./DevWeb.vue?vue&type=template&id=60e014f0"
import script from "./DevWeb.vue?vue&type=script&lang=js"
export * from "./DevWeb.vue?vue&type=script&lang=js"

import "./DevWeb.vue?vue&type=style&index=0&id=60e014f0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__